import SpecificationKeys from "../constants/SpecificationKeys";

export function setGPSInterval(values: $TSFixMe) {
  const specifications = {};
  if (values.gpsActive && values.gpsInterval) {
    // @ts-expect-error TS(2538) FIXME: Type 'string[]' cannot be used as an index type.
    specifications[[SpecificationKeys.GPSSettings.GPS_SEND_INTERVAL]] = {
      value: values.gpsInterval.id,
    };
    // @ts-expect-error TS(2538) FIXME: Type 'string[]' cannot be used as an index type.
    specifications[[SpecificationKeys.GPSSettings.GPS_SEND_LATEST_INTERVAL]] = {
      value: values.gpsInterval.id,
    };
  } else if (
    (values.gpsActive && !values.gpsInterval) ||
    (!values.gpsActive && !values.gpsInterval)
  ) {
    // @ts-expect-error TS(2538) FIXME: Type 'string[]' cannot be used as an index type.
    specifications[[SpecificationKeys.GPSSettings.GPS_SEND_INTERVAL]] = {
      value: "0",
    };
    // @ts-expect-error TS(2538) FIXME: Type 'string[]' cannot be used as an index type.
    specifications[[SpecificationKeys.GPSSettings.GPS_SEND_LATEST_INTERVAL]] = {
      value: "0",
    };
  } else {
    // @ts-expect-error TS(2538) FIXME: Type 'string[]' cannot be used as an index type.
    specifications[[SpecificationKeys.GPSSettings.GPS_SEND_INTERVAL]] = {
      value: "0",
    };
    // @ts-expect-error TS(2538) FIXME: Type 'string[]' cannot be used as an index type.
    specifications[[SpecificationKeys.GPSSettings.GPS_SEND_LATEST_INTERVAL]] = {
      value: values.gpsInterval.id,
    };
  }
  return specifications;
}
